/**
 * Sidebar Menu Configuration
 *
 * Unified Menu Structure (all items follow the same schema)
 */
// Menu items for Branches
export const branchMenuItems = [
    {
        title: 'منو',
        icon: "ri-dashboard-2-line",
        disabled: false,
        hidden: false,
        badge: null,
        items: [
            {
                label: 'صفحه اصلی',
                icon: 'ri-home-line',
                path: '/',
                disabled: false,
                badge: null
            },
            {
                id: 'exampleMenu',
                label: 'منوی نمونه',
                icon: 'ri-menu-line',
                disabled: false,
                badge: null,
                children: [
                    { label: 'زیر منو ۱', path: '/example-1' },
                    { label: 'زیر منو ۲', path: '/example-2' }
                ]
            },
            {
                id: 'productsMenu',
                label: 'محصولات',
                icon: 'ri-shopping-bag-line',
                disabled: false,
                badge: null,
                children: [
                    { label: 'دسته بندی', path: '/products/categories' },
                    { label: 'محصولات', path: '/products/list' },
                    { label: 'افزودنی های محصول', path: '/products/addons' },
                    { label: 'برچسب های محصول', path: '/products/tags' }
                ]
            },
            {
                id: 'websiteMenu',
                label: 'وب سایت آنلاین',
                icon: 'ri-global-line',
                disabled: false,
                badge: null,
                children: [
                    { label: 'تنظیمات وب سایت', path: '/website/settings' },
                    { label: 'فرم‌های منو', path: '/website/menu-forms' }
                ]
            },
            {
                id: 'ordersMenu',
                label: 'سفارشات رستوران',
                icon: 'ri-restaurant-2-line',
                disabled: false,
                badge: null,
                children: [
                    { label: 'سالن و ثبت سفارش', path: '/orders/floor' },
                    { label: 'لیست سفارش‌ها', path: '/orders/list' },
                    { label: 'فاکتورها', path: '/orders/invoices' },
                    { label: 'مدیریت میزها', path: '/orders/tables' },
                    { label: 'تنظیمات چاپگر', path: '/orders/printer-settings' }
                ]
            },
            {
                label: 'غیرفعال',
                icon: 'ri-prohibited-2-line',
                path: '#',
                disabled: true,
                badge: null
            }
        ]
    }
];
// Menu items for Accounting
export const accountingMenuItems = [
    {
        title: 'حسابداری',
        icon: "ri-calculator-line",
        disabled: false,
        hidden: false,
        badge: null,
        items: [
            {
                label: 'داشبورد',
                icon: 'ri-dashboard-2-line',
                path: '/accounting/dashboard',
                disabled: false,
                badge: null
            },
            {
                id: 'accountingExample',
                label: 'نمونه منو',
                icon: 'ri-menu-line',
                disabled: false,
                badge: null,
                children: [
                    { label: 'زیر منو ۱', path: '/accounting/example-1' },
                    { label: 'زیر منو ۲', path: '/accounting/example-2' }
                ]
            }
        ]
    }
];
// Menu items for CRM
export const crmMenuItems = [
    {
        title: 'CRM',
        icon: "ri-customer-service-2-line",
        disabled: false,
        hidden: false,
        badge: null,
        items: [
            {
                label: 'داشبورد',
                icon: 'ri-dashboard-2-line',
                path: '/crm/dashboard',
                disabled: false,
                badge: null
            },
            {
                id: 'crmExample',
                label: 'نمونه منو',
                icon: 'ri-menu-line',
                disabled: false,
                badge: null,
                children: [
                    { label: 'زیر منو ۱', path: '/crm/example-1' },
                    { label: 'زیر منو ۲', path: '/crm/example-2' }
                ]
            }
        ]
    }
];
// Default empty menu (used when no section is selected)
export const menuItems = [];
